import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AuthService} from '../auth/auth.service';
import {NavigationExtras, Router} from '@angular/router';
import {NgbDropdownConfig} from '@ng-bootstrap/ng-bootstrap';
import {UserBoardService} from '../../_services/user-board.service';
import {USER_BOARD} from '../values';
import {GymInfo} from '../../_models/_firebaseObjects/GymInfo';
import {Subscription} from 'rxjs/Rx';
import {UserModel} from '../../_models/_firebaseObjects/UserModel';
import {AdminService} from '../../_services/admin.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})

export class NavbarComponent implements OnInit, OnDestroy {
  getGymName = localStorage.getItem('gym_name') || 'Gym';
  personName = localStorage.getItem('person_name') || 'Gym admin';
  gymDetailsSubs: Subscription;
  userDetailsSubs: Subscription;

  isAdmin = false;

  @ViewChild('logoImage') private logoImage;
  profileImageURL: string = '';

  constructor(private authService: AuthService, private router: Router, private config: NgbDropdownConfig, private userBoardService: UserBoardService, private adminService: AdminService) {
    this.userDetailsSubs = this.adminService.getUserDetails().subscribe((user: UserModel) => {
      if(user && user.role === 'rootAdmin'){
        this.profileImageURL = 'assets/app/images/logo/LOGO_White.png';
        this.gymDetailsSubs = new Subscription();
        this.isAdmin = true;
        //this.removeItemsFromLocalStorage();
        return;
      }
      this.gymDetailsSubs = this.userBoardService.getGymDetails().subscribe((gymInfo: GymInfo) => {
        let logoUrl = gymInfo['logoURL'];
        if(logoUrl){
          localStorage.setItem('gym_logo', logoUrl)
        }
        if(gymInfo.profileImageURL) {
          this.profileImageURL = gymInfo.profileImageURL || 'assets/app/images/logo/LOGO_White.png';
        }
      });
    })
  }

  removeItemsFromLocalStorage() {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('gym_uid');
    localStorage.removeItem('gym_id');
    localStorage.removeItem('gym_name');
    localStorage.removeItem('person_name');
    localStorage.removeItem('gym_logo');
  }

  getLogoUrl() {
    //console.log(localStorage.getItem('gym_logo') || 'assets/app/images/logo/LOGO_White.png');
    return localStorage.getItem('gym_logo') || 'assets/app/images/logo/LOGO_White.png';
  }

  getImgSource() {
    if(this.profileImageURL) {
      return this.profileImageURL
    } else {
      return 'assets/app/images/loading.png';
    }
  }

  ngOnInit() {

  }

  logout() {
    this.authService.logout().then(() => {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('gym_uid');
      localStorage.removeItem('gym_id');
      localStorage.removeItem('gym_name');
      localStorage.removeItem('person_name');
      localStorage.removeItem('user_uid');
      localStorage.removeItem('gym_logo')
    })
  }

  zoomLogo() {
    console.log('click event on stack');
    this.logoImage.nativeElement.classList.toggle('logo-zoomed');
  }

  account() {
    this.router.navigate([USER_BOARD, 'account']);
  }

  ngOnDestroy(): void {
    this.gymDetailsSubs.unsubscribe();
    this.userDetailsSubs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/navbar/navbar.component.ts